import React from 'react';
import BookingFormStore from 'Stores/BookingFormStore';
import CheckedIcon from 'Icons/Checked';
import bemit from 'Functions/bemit';
export default function BookingFlowStatus({
  ...props
}) {
  const state = BookingFormStore.useState(function (store) {
    return {
      info: store.info,
      error: store.error,
      warning: store.warning
    };
  });
  return state.error ? /*#__PURE__*/React.createElement("div", {
    className: bemit('c-message', ['v2', 'red']) + ' u-margin-top-20 u-margin-bottom-0'
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-message__content"
  }, state.error)) : state.warning ? /*#__PURE__*/React.createElement("div", {
    className: bemit('c-message', ['v2', 'orange']) + ' u-margin-top-20 u-margin-bottom-0'
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-message__content"
  }, state.warning)) : state.info ? /*#__PURE__*/React.createElement("div", {
    className: bemit('c-message', ['v2', 'green', 'icon']) + ' u-margin-top-20 u-margin-bottom-0'
  }, /*#__PURE__*/React.createElement(CheckedIcon, {
    className: "c-message__icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "c-message__content"
  }, state.info)) : undefined;
}
